// Idempotency-Key generator for money-/stock-/points-/fiscal-affecting writes (contract §4).
// The client attaches one automatically on write calls flagged `idempotent: true`.
export function newIdempotencyKey() {
    const c = globalThis.crypto;
    if (c?.randomUUID)
        return c.randomUUID();
    // Fallback for environments without WebCrypto randomUUID.
    return "idem-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
}
//# sourceMappingURL=idempotency.js.map